import { render, staticRenderFns } from "./addOrEditVersion.vue?vue&type=template&id=b6a9360e&scoped=true"
import script from "./addOrEditVersion.vue?vue&type=script&lang=js"
export * from "./addOrEditVersion.vue?vue&type=script&lang=js"
import style0 from "./addOrEditVersion.vue?vue&type=style&index=0&id=b6a9360e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9360e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a9360e')) {
      api.createRecord('b6a9360e', component.options)
    } else {
      api.reload('b6a9360e', component.options)
    }
    module.hot.accept("./addOrEditVersion.vue?vue&type=template&id=b6a9360e&scoped=true", function () {
      api.rerender('b6a9360e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/miliEngineering/component/addOrEditVersion.vue"
export default component.exports